import { render } from "./stockAdjustmentApproval.vue?vue&type=template&id=1fcdd3b0"
import script from "./stockAdjustmentApproval.vue?vue&type=script&lang=js"
export * from "./stockAdjustmentApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__